/*
 * Operator Attribution Tracker v2.4
 * ---------------------------------
 * V2.4 Aenderungen:
 *  - Cart-Attribute drastisch reduziert. Nur noch 4 sichtbare Keys
 *    (Werbeanzeige, Quelle, Klickzeit, Geraet) plus 1 JSON-Feld "_op"
 *    fuer's Backend. Vorher 5 sichtbar + 10 _op_*-Keys = 15 Felder, jetzt
 *    5 Felder gesamt. Shopify zeigt alle Cart-Attrs unter "Weitere Details"
 *    an, daher minimal halten.
 *  - "_op" enthaelt {v, first, last, session, device} als JSON-String.
 *    First/Last sind {ad, src, cmp, ts} Objekte mit raw utm_content (Meta
 *    Ad ID oder Name) fuer deterministisches Backend-Matching.
 *  - "Kampagne" entfernt (zeigte nur numerische Campaign-ID, nutzlos).
 *  - "Werbeanzeige" zeigt strikt utm_content (kein "(ohne Ad-ID)"-Fallback
 *    mehr), damit der Wert zur _op.last.ad Property passt.
 *
 * V2.3 Aenderungen:
 *  - Cart-Attribute Keys neu strukturiert: 5 sichtbare Keys ohne Prefix
 *    ("Werbeanzeige", "Quelle", "Kampagne", "Klickzeit", "Geraet") zeigen
 *    den LAST Touch. Versteckte Keys mit _op_ Prefix tragen First + Last
 *    separat fuer 3-Modell-Attribution im Operator Backend
 *    (_op_first_ad/src/cmp/ts, _op_last_ad/src/cmp/ts, _op_session, _op_v).
 *  - Shopify versteckt Cart-Attribute mit _ Prefix in der Order-Detail-View
 *    "Weitere Details", sodass nur die sichtbaren Keys den Shop-Betreiber
 *    erreichen.
 *  - "Werbeanzeige" zeigt utm_content oder den Fallback "<source> (ohne
 *    Ad-ID)". "_op_last_ad" enthaelt RAW utm_content (Meta Ad ID) fuer
 *    deterministisches Backend-Matching.
 *
 * V2.2 Aenderungen:
 *  - localStorage ist OPTIONAL. Wenn blocked (Consent denied, ITP,
 *    Privacy-Modus, In-App-Browser): Snippet laeuft trotzdem, push wird
 *    bei jedem Pageview wiederholt (keine Hash-Dedupe ohne LS).
 *  - First-Touch Lock-In Bug behoben: referrer-only Touch (z.B. Google
 *    organic) wird durch spaeteren UTM-bearing Touch (Meta Ad) ueber-
 *    schrieben. Vorher blieb Erste Werbeanzeige leer wenn die erste
 *    Visit organic war.
 *  - Push laeuft IMMER, unabhaengig vom gtag-Consent. Cart-Attributes
 *    sind First-Party Shopify-Daten, kein Tracking.
 *  - Debug-Modus: ?op_debug=1 oder localStorage.op_debug=1.
 *
 * V2.1: Liest UTMs/Referrer bevorzugt aus window.OP_LANDING_URL und
 * window.OP_REFERRER (synchron via Liquid eingespritzt vor defer-Scripts).
 * fetch /cart/update.js nutzt keepalive:true.
 *
 * V2: Cart-Attribute Keys deutsch ohne Underscore-Prefix.
 *
 * Storage:
 *   localStorage[op_attr_v1] = JSON {
 *     first: { utm_content, utm_campaign, utm_source, utm_medium, utm_term,
 *              fbclid, gclid, landing_path, landing_query, referrer, ts },
 *     last:  { ... gleiche keys ... },
 *     session_id, ts_session_start
 *   }
 *   localStorage[op_cart_synced] = djb2-Hash der zuletzt gepushten Cart-Attributes
 *
 * Cart-Attribute Keys (deutsch, sichtbar im Admin):
 *   "Erste Werbeanzeige", "Erste Quelle", "Erste Kampagne", "Erste Klickzeit",
 *   "Letzte Werbeanzeige", "Letzte Quelle", "Letzte Kampagne", "Letzte Klickzeit",
 *   "Session", "Geraet", "Attribution Version" = "2"
 *
 * Defensiv: kein Throw, kein Block fuer Cart Drawer Logik. Alles in try/catch.
 *
 * Kanonische Quelle: operator/references/attribution-snippet/
 */

(function () {
  "use strict";
  var STORAGE_KEY = "op_attr_v1";
  var CART_SYNCED_KEY = "op_cart_synced";
  var VERSION = "2";
  var MAX_FIELD_LEN = 200;

  var DEBUG = (function () {
    try {
      if (/[?&]op_debug=1\b/.test(window.location.search || "")) return true;
      if (typeof localStorage !== "undefined" && localStorage.getItem("op_debug") === "1") return true;
    } catch (e) {}
    return false;
  })();

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, ["[op-attr]"].concat(Array.prototype.slice.call(arguments))); } catch (e) {}
  }

  function safe(fn) {
    try { return fn(); } catch (e) { return null; }
  }

  function nowIso() {
    return new Date().toISOString();
  }

  function uuid() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      try { return crypto.randomUUID(); } catch (e) {}
    }
    return "op-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
  }

  function readUrlParams() {
    var p = {};
    safe(function () {
      var href = (typeof window.OP_LANDING_URL === "string" && window.OP_LANDING_URL)
                  ? window.OP_LANDING_URL
                  : window.location.href;
      var u = new URL(href);
      var keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"];
      keys.forEach(function (k) {
        var v = u.searchParams.get(k);
        if (v) p[k] = String(v).slice(0, MAX_FIELD_LEN);
      });
    });
    return p;
  }

  function readReferrer() {
    var r = "";
    safe(function () {
      var raw = (typeof window.OP_REFERRER === "string") ? window.OP_REFERRER : document.referrer;
      r = String(raw || "").slice(0, MAX_FIELD_LEN);
      if (r) {
        try {
          var ref = new URL(r);
          if (ref.origin === window.location.origin) r = "";
        } catch (e) {}
      }
    });
    return r;
  }

  function detectDevice() {
    return safe(function () {
      var ua = (navigator.userAgent || "").toLowerCase();
      if (/ipad|tablet/.test(ua)) return "tablet";
      if (/mobi|android|iphone|ipod/.test(ua)) return "mobile";
      return "desktop";
    }) || "unknown";
  }

  // localStorage-Wrapper. Beide Funktionen returnen null/false bei Block.
  function loadState() {
    return safe(function () {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (!s || typeof s !== "object") return null;
      return s;
    });
  }

  function saveState(s) {
    return safe(function () {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
      return true;
    }) === true;
  }

  // Echter Ad-Touch: hat utm_* oder fbclid/gclid. Referrer alleine zaehlt nicht.
  function hasUtmOrClickId(touch) {
    if (!touch) return false;
    return !!(touch.utm_content || touch.utm_campaign || touch.utm_source || touch.fbclid || touch.gclid);
  }

  // Beliebiges Marketing-Signal inkl. externer Referrer.
  function hasAnyMarketing(touch) {
    if (!touch) return false;
    return hasUtmOrClickId(touch) || !!touch.referrer;
  }

  function buildTouch() {
    var p = readUrlParams();
    return {
      utm_content:  p.utm_content  || "",
      utm_campaign: p.utm_campaign || "",
      utm_source:   p.utm_source   || "",
      utm_medium:   p.utm_medium   || "",
      utm_term:     p.utm_term     || "",
      fbclid:       p.fbclid       || "",
      gclid:        p.gclid        || "",
      landing_path: safe(function () { return String(window.location.pathname || "").slice(0, MAX_FIELD_LEN); }) || "",
      landing_query: safe(function () { return String(window.location.search || "").slice(0, MAX_FIELD_LEN); }) || "",
      referrer:     readReferrer(),
      ts:           nowIso(),
    };
  }

  // Baut state aus current touch + optionalem persistierten state. Robust
  // gegen blocked localStorage: wenn loadState null liefert, wird state
  // komplett aus current gefuellt. Wenn current keine Marketing-Daten hat,
  // bleibt first/last null und es werden nur Session/Geraet/Version gepusht.
  //
  // Wichtige Regel zum First-Touch Lock-In:
  //   - Persistierter First-Touch MIT UTM/clickid bleibt gelockt.
  //   - Persistierter First-Touch OHNE UTM/clickid (referrer-only) wird
  //     ueberschrieben sobald ein UTM-bearing Touch reinkommt. So wird
  //     "Erste Werbeanzeige" auf den Meta-Ad-Klick gesetzt, auch wenn der
  //     erste Site-Besuch ein Google-Organic-Visit war.
  function buildState() {
    var current = buildTouch();
    var existing = loadState();

    var first;
    if (existing && existing.first && hasUtmOrClickId(existing.first)) {
      first = existing.first;
    } else if (hasUtmOrClickId(current)) {
      first = current;
    } else if (existing && existing.first) {
      first = existing.first;
    } else if (hasAnyMarketing(current)) {
      first = current;
    } else {
      first = null;
    }

    var last;
    if (hasAnyMarketing(current)) {
      last = current;
    } else if (existing && existing.last) {
      last = existing.last;
    } else {
      last = null;
    }

    var sessionId = (existing && existing.session_id) || uuid();
    var sessionStart = (existing && existing.ts_session_start) || nowIso();

    var state = { first: first, last: last, session_id: sessionId, ts_session_start: sessionStart };
    saveState(state);
    return state;
  }

  function formatDeDate(iso) {
    return safe(function () {
      if (!iso) return "";
      var d = new Date(iso);
      if (isNaN(d.getTime())) return "";
      var pad = function (n) { return n < 10 ? "0" + n : String(n); };
      return pad(d.getDate()) + "." + pad(d.getMonth() + 1) + "." + d.getFullYear()
           + " " + pad(d.getHours()) + ":" + pad(d.getMinutes());
    }) || "";
  }

  function adLabel(touch) {
    if (!touch) return "";
    if (touch.utm_content) return touch.utm_content;
    if (touch.utm_source) return touch.utm_source + " (ohne Ad-ID)";
    return "";
  }

  // Nur die utm_*-Felder eines Touches in ein kompaktes Objekt fuer den
  // _op-JSON-Blob extrahieren. Felder die leer sind, werden weggelassen
  // damit der JSON-String klein bleibt.
  function compactTouch(touch) {
    if (!touch) return null;
    var t = {};
    if (touch.utm_content)  t.ad  = touch.utm_content;
    if (touch.utm_source)   t.src = touch.utm_source;
    if (touch.utm_campaign) t.cmp = touch.utm_campaign;
    if (touch.ts)           t.ts  = touch.ts;
    var keys = Object.keys(t);
    if (keys.length === 0) return null;
    return t;
  }

  function buildCartAttributes(state) {
    var attrs = {};
    var last = state.last;

    // 4 sichtbare Felder im Shopify Admin (zeigen LAST Touch ausser Geraet).
    // Das ist alles was der Shop-Betreiber unter "Weitere Details" sehen soll.
    if (last) {
      if (last.utm_content)  attrs["Werbeanzeige"] = last.utm_content;
      if (last.utm_source)   attrs["Quelle"]       = last.utm_source;
      var lastTsHuman = formatDeDate(last.ts);
      if (lastTsHuman)       attrs["Klickzeit"]    = lastTsHuman;
    }
    attrs["Geraet"] = detectDevice();

    // Ein einziges Backend-Feld "_op" mit allem als JSON. Shopify zeigt es
    // zwar an, aber als ein einziger kompakter String statt 10 separater
    // Zeilen. Operator-Backend parsed das JSON via attribution.ts.
    var op = { v: VERSION };
    var firstCompact = compactTouch(state.first);
    var lastCompact = compactTouch(last);
    if (firstCompact) op.first = firstCompact;
    if (lastCompact)  op.last  = lastCompact;
    if (state.session_id) op.session = state.session_id;
    op.device = detectDevice();
    attrs["_op"] = JSON.stringify(op);

    return attrs;
  }

  function shallowHash(obj) {
    return safe(function () {
      var keys = Object.keys(obj).sort();
      var s = "";
      for (var i = 0; i < keys.length; i++) s += keys[i] + "=" + obj[keys[i]] + ";";
      var h = 5381;
      for (var j = 0; j < s.length; j++) h = ((h << 5) + h + s.charCodeAt(j)) | 0;
      return String(h);
    }) || "";
  }

  // Push ist UNABHAENGIG von Consent oder localStorage. /cart/update.js ist
  // ein First-Party Shopify-Endpoint, keine Tracking-Quelle. Wenn localStorage
  // blockiert ist, faellt die Hash-Dedupe weg und wir pushen auf jedem
  // Pageview neu - das ist OK weil Shopify die Attribute idempotent merged.
  function pushToCart(attrs) {
    safe(function () {
      var hash = shallowHash(attrs);
      var lastHash = safe(function () { return localStorage.getItem(CART_SYNCED_KEY); });
      if (lastHash && lastHash === hash) {
        log("skip push (hash unchanged)", hash);
        return;
      }
      log("push", attrs);
      fetch("/cart/update.js", {
        method: "POST",
        keepalive: true,
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ attributes: attrs }),
      }).then(function (r) {
        if (r && r.ok) {
          log("push ok", r.status);
          safe(function () { localStorage.setItem(CART_SYNCED_KEY, hash); });
        } else {
          log("push failed", r && r.status);
        }
      }).catch(function (e) {
        log("push error", e && e.message);
      });
    });
  }

  function init() {
    safe(function () {
      if (window.Shopify && window.Shopify.designMode) return;
      var state = buildState();
      var attrs = buildCartAttributes(state);
      log("init", {
        op_landing_url: typeof window.OP_LANDING_URL === "string" ? window.OP_LANDING_URL : null,
        op_referrer: typeof window.OP_REFERRER === "string" ? window.OP_REFERRER : null,
        first_utm: state.first && state.first.utm_content,
        last_utm: state.last && state.last.utm_content,
        attrs: attrs,
      });
      pushToCart(attrs);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
